import Vue from 'vue';
import weka from './weka/weka.vue';
Vue.component('weka', weka);
